import { render, staticRenderFns } from "./RecipesFilter.vue?vue&type=template&id=65e2b040&"
import script from "./RecipesFilter.vue?vue&type=script&lang=js&"
export * from "./RecipesFilter.vue?vue&type=script&lang=js&"
import style0 from "./RecipesFilter.vue?vue&type=style&index=0&id=65e2b040&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports